import React, { Dispatch, SetStateAction, useState } from 'react';
import { selectCodiceStatoCavallo, selectQuotaFromEsitoMap } from 'features/ippica/selectors';
import { useCartToggleHandler, useIsInCart } from 'features/carrello/hooks';

import { IppicaScommesseTableInfoList } from '../ippicaScommesseTableInfoList';
import { IppicaScommesseTableMainInfo } from '../ippicaScommesseTableMainInfo';
import { IppicaScommesseTableMoreInfoButton } from '../ippicaScommesseTableMoreInfoButton';
import { IppicaScommesseTablePosition } from '../ippicaScommesseTablePosition';
import { IppicaScommesseTableSecondaryInfo } from '../ippicaScommesseTableSecondaryInfo/IppicaScommesseTableSecondaryInfo';
import { ScommesseTipoBoxUiContainer } from '../../ippicaScommesseEsitoTipoBox/IppicaScommesseEsitoTipoBox';
import { breakpoint } from 'utility/constant';
import { isStatoCavalloRetired } from 'features/ippica/functions';
import styles from './IppicaScommesseTableRowTestaATesta.module.scss';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize, { enComparer } from 'hooks/useWindowSize';

export type IppicaScommesseTableRowTestaATestaProps = {
  keyCavalloList: string[];
  keyQuotaList: string[];
  providerID?: number;
};

export const IppicaScommesseTableRowTestaATesta = ({
  keyCavalloList,
  keyQuotaList,
  providerID,
}: IppicaScommesseTableRowTestaATestaProps) => {
  const [isOpenMoreInfoA, setIsOpenMoreInfoA] = useState<boolean>(false);
  const [isOpenMoreInfoB, setIsOpenMoreInfoB] = useState<boolean>(false);

  return (
    <div className={styles.wrapper}>
      <IppicaScommesseTableColumnTestaATesta
        keyCavallo={keyCavalloList[0]}
        keyQuota={keyQuotaList[0]}
        isReverse
        isOpenMoreInfo={isOpenMoreInfoA}
        setIsOpenMoreInfo={setIsOpenMoreInfoA}
        providerID={providerID}
      />
      <IppicaScommesseTableColumnTestaATesta
        keyCavallo={keyCavalloList[1]}
        keyQuota={keyQuotaList[1]}
        isOpenMoreInfo={isOpenMoreInfoB}
        setIsOpenMoreInfo={setIsOpenMoreInfoB}
        providerID={providerID}
      />
    </div>
  );
};

export type IppicaScommesseTableColumnTestaATestaProps = {
  keyCavallo: string;
  keyQuota: string;
  isReverse?: boolean;
  isOpenMoreInfo: boolean;
  setIsOpenMoreInfo: Dispatch<SetStateAction<boolean>>;
  providerID: number | undefined;
};

const IppicaScommesseTableColumnTestaATesta = ({
  keyCavallo,
  keyQuota,
  isReverse,
  isOpenMoreInfo,
  setIsOpenMoreInfo,
  providerID,
}: IppicaScommesseTableColumnTestaATestaProps) => {
  const { doCheck } = useWindowSize();
  const [isMobile] = doCheck([{ comparer: enComparer.less, size: breakpoint.lg }]);

  const cartHandler = useCartToggleHandler(keyQuota);
  const quota = useTypedSelector(selectQuotaFromEsitoMap(keyQuota));
  const isActiveInCart = useIsInCart(keyQuota);
  const codiceStatoCavallo = useTypedSelector(selectCodiceStatoCavallo(keyCavallo));
  const isDisabled = isStatoCavalloRetired(codiceStatoCavallo) || quota === 100;
  return (
    <div className={`${styles.container} ${isReverse && styles.reverse}`}>
      <IppicaScommesseTablePosition
        keyCavallo={keyCavallo}
        containerClassName={styles.position}
        isOpen={isOpenMoreInfo}
        isReverse={isReverse}
      />
      <IppicaScommesseTableMainInfo
        containerClassName={styles.mainInfo}
        keyCavallo={keyCavallo}
        isOpen={isOpenMoreInfo}
        isReverse={isReverse}
        isTestaATesta
      />
      <ScommesseTipoBoxUiContainer
        quota={quota}
        containerClassName={styles.quote}
        cartHandler={cartHandler}
        isActiveInCart={isActiveInCart}
        isDisable={isDisabled}
        scommessaKey={keyQuota}
      />
      <div className={`${styles.hideElement} ${isOpenMoreInfo ? styles.visible : ''}`}>
        {isMobile && (
          <IppicaScommesseTableSecondaryInfo
            containerClassName={styles.secondaryInfo}
            providerID={providerID}
            keyCavallo={keyCavallo}
            isOpen={isOpenMoreInfo}
          />
        )}
        <IppicaScommesseTableInfoList keyCavallo={keyCavallo} />
      </div>
      <IppicaScommesseTableMoreInfoButton
        isOpen={isOpenMoreInfo}
        setIsOpen={setIsOpenMoreInfo}
        containerClassName={styles.moreBtn}
      />
    </div>
  );
};
